import client from '../client'
import qs from 'qs'

export const getProductList = async ({ lastPosNo, limit }) => {
  const queryString = qs.stringify({
    last_pos_no: lastPosNo,
    limit,
  })
  const response = await client.get(`/commerce/products?${queryString}`)

  return response.data
}
